<template>
    <v-alert
        v-if="shouldShow"
        :type="alertType"
        :color="alertColor"
        prominent
        border="left"
        class="mb-4"
        dismissible
        @input="onDismiss"
    >
        <v-row align="center">
            <v-col class="grow">
                <div class="d-flex align-center">
                    <v-icon :color="iconColor" large class="mr-3">
                        {{ icon }}
                    </v-icon>
                    <div>
                        <h3 class="text-h6 font-weight-bold">
                            {{ title }}
                        </h3>
                        <p class="mb-0">
                            {{ message }}
                        </p>
                    </div>
                </div>
            </v-col>
            <v-col class="shrink">
                <v-btn
                    :color="buttonColor"
                    @click="contactSupport"
                    elevation="2"
                >
                    <v-icon left>mdi-email</v-icon>
                    Renovar Acesso
                </v-btn>
            </v-col>
        </v-row>
    </v-alert>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'ProExpirationBanner',
    
    data() {
        return {
            dismissed: false
        };
    },
    
    computed: {
        ...mapGetters('auth', ['profileStatus', 'isExpiringSoon', 'daysUntilExpiration']),
        
        shouldShow() {
            // Não mostrar se foi dispensado nesta sessão
            if (this.dismissed) return false;
            
            // Mostrar apenas se está expirando em breve ou já expirou
            return this.profileStatus.isExpiringSoon || this.profileStatus.isExpired;
        },
        
        alertType() {
            if (this.profileStatus.isExpired) return 'error';
            if (this.daysUntilExpiration <= 3) return 'error';
            if (this.daysUntilExpiration <= 7) return 'warning';
            return 'info';
        },
        
        alertColor() {
            if (this.profileStatus.isExpired) return 'error';
            if (this.daysUntilExpiration <= 3) return 'error';
            if (this.daysUntilExpiration <= 7) return 'warning';
            return 'info';
        },
        
        icon() {
            if (this.profileStatus.isExpired) return 'mdi-alert-circle';
            return 'mdi-clock-alert';
        },
        
        iconColor() {
            return 'white';
        },
        
        buttonColor() {
            if (this.profileStatus.isExpired) return 'white';
            if (this.daysUntilExpiration <= 3) return 'white';
            return 'primary';
        },
        
        title() {
            if (this.profileStatus.isExpired) {
                return '⚠️ Seu acesso Premium expirou!';
            }
            
            if (this.daysUntilExpiration === 0) {
                return '⏰ Seu acesso Premium expira hoje!';
            }
            
            if (this.daysUntilExpiration === 1) {
                return '⏰ Seu acesso Premium expira amanhã!';
            }
            
            return `⏰ Seu acesso Premium expira em ${this.daysUntilExpiration} dias!`;
        },
        
        message() {
            if (this.profileStatus.isExpired) {
                return 'Seu período de avaliação Premium expirou. Escolha um plano pago para continuar utilizando a plataforma.';
            }
            
            return 'Não perca acesso às funcionalidades premium. Renove agora e continue aproveitando todos os benefícios!';
        }
    },
    
    methods: {
        onDismiss() {
            this.dismissed = true;
        },
        
        contactSupport() {
            // Aqui você pode adicionar lógica para abrir modal de contato
            // ou redirecionar para página de renovação
            this.$swal({
                icon: 'info',
                title: 'Renovar Acesso Premium',
                html: `
                    <p>Entre em contato conosco para renovar seu acesso Premium:</p>
                    <ul style="text-align: left; padding-left: 20px;">
                        <li>📧 Email: amelsytech@gmail.com</li>
                        <li>📱 WhatsApp: (41) 99746-3830</li>
                    </ul>
                `,
                confirmButtonText: 'Entendi',
                confirmButtonColor: '#4CAF50'
            });
        }
    }
};
</script>

<style scoped>
.v-alert {
    animation: slideDown 0.3s ease-out;
}

@keyframes slideDown {
    from {
        opacity: 0;
        transform: translateY(-20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}
</style>
